import { IPaginationParams, IPaginationResponse } from 'interfaces/pagination';
import * as rxjs from 'rxjs';

import apiService, { ApiService } from './api';

export class ReportService {
  constructor(private apiService: ApiService) { }

  public report(params: IPaginationParams, ventureId: number, reportType: string): rxjs.Observable<IPaginationResponse<any>> {
    return this.apiService.get(`/file/report/${reportType}/venture/${ventureId}`, {
      ...params, reportType
    });
  }

  public exportReportAccessXLS(): rxjs.Observable<any> {
    return this.apiService.post('/user/report/xls', {});
  }

  public exportCSV(ventureId: number): rxjs.Observable<any> {
    return this.apiService.post(`/file/report/csv/venture/${ventureId}`, {});
  }

  public exportXLS(ventureId: number, reportType?: string): rxjs.Observable<any> {
    return this.apiService.post(`/file/report/${reportType}/xls/venture/${ventureId}`, {});
  }

}

const reportService = new ReportService(apiService);
export default reportService;
